import { User } from "interfaces/user";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";
import { makeQueryString } from "core/makeQueryString";

interface LazyFetchResponse {
  count?: number;
  results?: User[];
}

interface LazyFetchUser {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetUsers = ({
  page = 1,
  pageSize = 10000
}: {
  page?: number;
  pageSize?: number;
}): {
  loading: boolean;
  error: boolean;
  fetchUsers: (queryParams?: Record<string, any>) => Promise<LazyFetchResponse>;
} => {
  const { loading, error, fetchCallback }: LazyFetchUser = useLazyFetchV2(
    "GET"
  );

  return {
    loading,
    error,
    fetchUsers: (queryParams?: Record<string, any>) => {
      const params = { page, size: pageSize, ...queryParams };
      const queryString = makeQueryString(params);

      return fetchCallback(`users${queryString}`);
    }
  };
};
